import { useState, useEffect } from 'react';
import { Button, Modal } from 'react-bootstrap';
import { Link, useNavigate } from "react-router-dom";
// import Select from "react-select";
import DatePicker from "react-multi-date-picker";


// import React, { useEffect, useState } from 'react';
// import { Button, Modal } from 'react-bootstrap';
import Select, {components} from "react-select";
import axios from 'axios';
// import { Link } from "react-router-dom";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';


const Add = ({ show, onClose, refresh }) => {

       const baseURL = process.env.REACT_APP_API_BASE_URL;
       const [ledgerOptions, setLedgerOptions] = useState([]);
       const [subledgerOptions, setSubledgerOptions] = useState([]);
       const [selectedOption, setSelectedOption] = useState(null);
       const [SubSelectedOption, setSubSelectedOption] = useState(null);
       const [account_date, setAccountDate] = useState(null);
       const [ledger_account_name, setLedgerAccount] = useState(null);
       const [amount, setAmount] = useState(null);
       const [description, setDescription] = useState(null);

       const [errors, setErrors] = useState({});
       const [itemcatErrors, setItemcatErrors] = useState({});
       const [isFocused] = useState(false);
       const [selectedValue, setSelectedValue] = useState('');
        const navigate = useNavigate();


        const handleRadioChange = (event) => {
        setSelectedValue(event.target.value);
        };

    const handleDateChange = (dateValue) => {
        // Format the selected date to 'YYYY-MM-DD' and store it in the state
        // alert(dateValue);
        if (dateValue) {
          const formattedDate = dateValue.format('YYYY-MM-DD');
        // alert(formattedDate);

          setAccountDate(formattedDate);
        } else {
          setAccountDate(null);
        }
    };

        // useEffect(() => {
        //     if (isFocused) {
        //         console.log('The input is focused!');
        //     }
        // }, [isFocused]);
    
             useEffect(() => {
               const fetchledger = async () => {
                   try {
                       const response = await axios.get(`${baseURL}/manage-daily-accounts/get-ledger`);
                       const ledger = response.data.data.map(ledgers => ({
                             label: ledgers.ledger_name,
                               value: ledgers.sno
                       }));
                        setLedgerOptions(ledger);
                   } catch (error) {
                       console.error("Failed to fetch ledger:", error);
                   }
               };
               fetchledger();
           }, [baseURL]);

            useEffect(() => {
                if (selectedOption) {
                const fetchsubledger = async () => {
                                    try {
                                        const response = await axios.get(`${baseURL}/manage-daily-accounts/get-sub-ledger/${selectedOption.value}`);
                                        const sub_ledger = response.data.data.map(ledgers => ({
                                                label: ledgers.subledger_name,
                                                value: ledgers.sno
                                        }));
                                            setSubledgerOptions(sub_ledger);
                                    } catch (error) {
                                        console.error("Failed to fetch ledger:", error);
                                    }
                                };
                                fetchsubledger();
                }
            }, [selectedOption]);

 
    const validateForm = () => {
        const formErrors = {};
        const itemcatValidationErrors = {};

        if (!account_date) {
            formErrors.account_date = "Account Date is required";
        }
        if (!ledger_account_name) {
            formErrors.ledger_account_name = "Ledger Account Name is required"; 
        }
        if(!amount) {
            formErrors.amount = "Amount is required"; 
        }
        if(!description) {
            formErrors.description = "Description is required"; 
        }
       
        if (!selectedOption) {
            formErrors.ledger_id = "Ledger is required"; 
        }
        if (!SubSelectedOption) {
            formErrors.sub_ledger_id = "Sub Ledger is required"; 
        }
    
        if (!selectedValue) {
            formErrors.is_credit = "Credit or Debit is required"; 
        }
       
        setErrors(formErrors);
        setItemcatErrors(itemcatValidationErrors);

        return Object.keys(formErrors).length === 0 && Object.keys(itemcatValidationErrors).length === 0;
    };
 

      const handleFormSubmit = async () => {
            const isValid = validateForm();
            if (!isValid) return;
    
            const dailyAccounts = {
                account_date: account_date,
                ledger_account_name: ledger_account_name,
                amount: amount,
                ledger_id: selectedOption.value,
                sub_ledger_id: SubSelectedOption.value,
                is_credit: selectedValue,
                description:description
            };
    
            try {
                const response = await axios.post(`${baseURL}/manage-daily-accounts/create`, dailyAccounts);
                if (response.status === 201) {
                    // alert("Package created successfully!");
                    onClose();
                    refresh();
                    toast.success("Accounts Created Successfully!");
                    //  navigate('/daily-accounts');
                    // window.location.reload();
                }
            } catch (error) {

                 onClose();
                    refresh();
                    toast.success(error);
                // console.error("Error creating package:", error.response?.data || error);
                // alert(error.response?.data?.message || "There was an error creating the package.");
            }
        };

    return (
        <Modal show={show} onHide={onClose} size="lg">
            <div className="modal-content border border-red rounded-xxl">
                <div className="modal-header" style={{ backgroundColor: '#3ab384' }}>
                    <h3 className="modal-title text-white">Create Daily Accounts</h3>
                    <Button variant="" type="button" className="close px-6 py-2" data-dismiss="modal" onClick={onClose}>
                        <span className="text-white">×</span>
                    </Button>
                </div>
                <div className="modal-body">
                    <div className="row">
                        <div className="col-lg-6 mb-2">
                            <label className="text-black font-w500 fs-7">Date<span className="required">*</span></label>
                            <div className='datepicker-wrapper d-flex'>
                                <div className='input-group-text bg-transparent border-0 px-0'><i className='fa-solid fa-calendar-days fs-4'></i></div>
                                <DatePicker placeholder='Select Date'
                                    format="DD-MM-YYYY"
                                    // value={account_date}
                                    onChange={handleDateChange}
                                />
                                
                            </div>
                              {errors.account_date && <span className="text-danger">{errors.account_date}</span>}
                        </div>
                        <div className="col-lg-6 mb-2">
                            <label className="text-black font-w500 fs-7">Ledger <span className="required">*</span></label>
                            <Select placeholder='Select Ledger'
                                defaultValue={selectedOption}
                                onChange={setSelectedOption}
                                options={ledgerOptions}
                                //  onChange={handleFirstSelectChange}
                            /> 
                              {errors.ledger_id && <span className="text-danger">{errors.ledger_id}</span>}
                        </div>
                        <div className="col-lg-6 mb-2">
                            <label className="text-black font-w500 fs-7">Sub Ledger <span className="required">*</span></label>
                            <Select placeholder='Select Sub Ledger'
                                defaultValue={SubSelectedOption}
                                onChange={setSubSelectedOption}
                                options={subledgerOptions}
                               
                            />
                             {errors.sub_ledger_id && <span className="text-danger">{errors.sub_ledger_id}</span>}
                        </div>
                        <div className="col-lg-6 mb-2">
                            <label className="text-black font-w500 fs-7">Ledger Account <span className="required">*</span></label>
                            <input placeholder='Ledger Account ' type="text" className="form-control"   value={ledger_account_name}
                                    onChange={(e) => setLedgerAccount(e.target.value)} />
                             {errors.ledger_account_name && <span className="text-danger">{errors.ledger_account_name}</span>}

                        </div>
                        <div className="col-lg-6 mb-2">
                            <label className="text-black font-w500 fs-7">Amount <span className="required">*</span></label>
                            <input placeholder='Amount ' type="number" className="form-control" value={amount}
                                    onChange={(e) => setAmount(e.target.value)} />
                             {errors.amount && <span className="text-danger">{errors.amount}</span>}
                        </div>
                        <div className="col-lg-6 mb-4">
                            <div className='mt-4 pt-3'>
                                <div className="form-check-inline">
                                    <input
                                        className="form-check-input"
                                        type="radio"
                                        name="is_credit"
                                        value="1"
                                         onChange={handleRadioChange}
                                        
                                    />
                                    
                                    <label className="form-check-label fs-7">
                                        Credit
                                    </label>
                                </div>
                                <div className="form-check-inline">
                                    <input
                                        className="form-check-input"
                                        type="radio"
                                        name="is_credit"
                                        value="0"
                                         onChange={handleRadioChange}
                                    />
                                    <label className="form-check-label fs-7">
                                        Debit
                                    </label>
                                </div>
                                  {errors.is_credit && <span className="text-danger">{errors.is_credit}</span>}
                            </div>
                        </div>

                        <div className="col-lg-12 mb-2">
                            <label className="text-black font-w500 fs-7">Description <span className="required">*</span></label>
                            <textarea rows={2} className="form-control h-auto" name="comment" placeholder="Description" value={description}
                                    onChange={(e) => setDescription(e.target.value)} />
                                     {errors.description && <span className="text-danger">{errors.description}</span>}
                        </div>
                    </div>
                    <div className="d-flex align-items-center justify-content-center gap-3 mt-4 mb-4">
                        <Link type="reset" className="btn btn-sm btn-secondary" onClick={onClose}>Cancel</Link>
                        <Link type="submit" className="btn btn-sm btn-primary" onClick={handleFormSubmit}>Create Daily Accounts</Link>
                    </div>
                </div>
            </div>
        </Modal>
    );
};

export default Add;
